(ns ycweb.util.urlstate
  (:require
   [cemerick.url :as url]
   #?@(:cljs
       [[goog.events]
        [cljs.reader :as edn]]
       :clj
       [[clojure.edn :as edn]
        [util.core :as uc]])
   [util.string :as str]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.util.core :as u])
  #?(:cljs
     (:import
      [goog.history EventType Html5History])))

(defn url-param
  "Read a query parameter directly from the current browser URL."
  [param-name]
  #?(:cljs
     (when-let [search (some-> js/window .-location .-search)]
       (some-> (js/URLSearchParams. search) (.get param-name)))
     :clj nil))

(defonce ^:dynamic history-atom
  (atom
    {:history nil :bindings {}
     :config {}
     :root nil
     :rootstates {}}))

(defmulti screen-params-shape (fn [screen] screen))

(defmethod screen-params-shape :default [_]
  nil)

(defn redirect! [loc]
  #?(:cljs
     (let [protocol (.-protocol (.-location js/window))
           hostname (.-hostname (.-location js/window))]
       (set! (.-location js/window) (str protocol "//" hostname loc)))))

(defn current-url []
  #?(:cljs
     (.-href (.-location js/window))))

(defn get-token [history {:keys [fragment?]}]
  #?(:cljs
     (if fragment?
       (.getToken ^Html5History history)
       (str/replace
         (str js/window.location.pathname js/window.location.search)
         #"(^[/])" ""))
     :clj
     (str/replace
       (:token history)
       #"(^[/])" "")))

(def screen-redirects
  {:web.cooking-school-my-courses :web.cooking-school/my-courses
   :web.cooking-school-available-courses :web.cooking-school/available-courses
   :web.cooking-school/courseregister :web.cooking-school/my-courses
   :web.myaccount/track :web.myaccount/orders
   :web.myaccount/preferences :web.myaccount/newsletters})

(defn- decode-param
  "Query values arrive percent-encoded and update-url re-encodes them on the way
   out, so they have to be decoded here or every round trip adds an escape layer
   — a space becoming %20, then %2520. Falls back to the raw value because
   url-decode throws on a stray % (\"50% off\"), and a malformed param must not
   break navigation."
  [v]
  (try
    (url/url-decode v)
    (catch #?(:clj Exception :cljs :default) _
      v)))

(defn current-values [token {:keys [base-prefix screen-action? fragment?]}]
  (let [[root vs] (str/split token #"[?]" 2)

        {:strs [action sku vid id] :as qvals}
        (->>
          (str/split vs #"[&]")
          (map (fn [s] (str/split s #"[=]" 2)))
          (filter (comp u/presence first))
          (map (fn [[n v]] [n (decode-param (or v "1"))]))
          (into {}))

        base
        (-> root
          (str/replace #"^admin/" "")
          (str/replace #"[.]htm$" "")
          (str/lower))

        root
        (if fragment?
          root
          base)

        root
        (if base-prefix
          (str base-prefix root)
          root)

        simple-root
        (cond
          (and action screen-action?)
          (keyword root action)

          :else
          (keyword root))

        screen-redirect (get screen-redirects simple-root)

        root
        (if root
          (cond
            fragment?
            (keyword root)

            (contains? (methods flow/render-screen) simple-root)
            simple-root

            screen-redirect
            screen-redirect

            (or (u/presence sku) (u/presence vid) (u/presence id))
            (keyword (str base-prefix "product"))

            :else
            (keyword (str base-prefix "dynamic")))
          :history/empty)]
    {:root root
     :base base
     :vals
     (if screen-action?
       (dissoc qvals "action")
       qvals)}))

(defn update-url [use-history?]
  (let [{:keys [history root bindings config]} @history-atom]
    ;; Only update when using fragment.
    (when (:fragment? config)
      (let [current-token (get-token history config)

            ;; Need to keep unbound variables in place if on the same root.
            current
            (current-values current-token config)

            ;; Push these into the old root states, so if we switch root, we can just pull it.
            _ (swap! history-atom assoc-in [:rootstates (:root current)] (:vals current))
            updated
            (merge
              (get (:rootstates @history-atom) @root {})
              (when (and (:screen-action? config) (u/presence (namespace @root)))
                {"action" (name @root)})
              (->>
                (get bindings @root [])
                (map
                  (fn [[nm {:keys [a coerce-type]}]]
                    (let [v @a]
                      (when v
                        [nm
                         (case coerce-type
                           :keyword (u/keyword-string v)
                           :vector (str/join "," v)
                           :set (str/join "," v)
                           (str v))]))))
                (remove nil?)
                (into {})))

            query
            (->>
              updated
              (map (fn [[nm val]] (str (url/url-encode nm) "=" (url/url-encode val))))
              (interpose "&")
              (apply str)
              (u/presence))

            token
            (str
              (if (:fragment? config)
                (u/glue "/" (namespace @root) (name @root))
                (str "/"
                  (if (:base-prefix config)
                    (str/replace-first (or (u/presence (namespace @root)) (name @root)) (:base-prefix config) "")
                    (namespace @root))
                  ".htm"))
              (when query "?")
              query)]

        (when-not (= current-token token)
          #?(:cljs
             (if use-history?
               (.setToken history token)
               (.replaceToken history token))
             :clj
             (swap! history-atom assoc-in [:history :token] token)))))))

(defn update-bindings []
  (let [{:keys [history bindings root config]} @history-atom
        {:keys [base-prefix screen-action? fragment?]} config
        current-token (get-token history config)
        current (current-values current-token config)
        root-bindings (get bindings (:root current))]

    (reset! root (:root current))
    (doseq [[nm v] (:vals current)]
      ;; Only try update stuff that is actually bound, of course xD
      (when (contains? root-bindings nm)
        (let [{:keys [a coerce-type] :as b} (get root-bindings nm)
              v-decoded (url/url-decode v)]
          (reset! a
            (when (u/presence v)
              (case coerce-type
                :keyword (keyword v-decoded)
                :integer (u/parseInt v)
                :float (u/parseFloat v)
                :vector (vec (str/split v-decoded #","))
                :set (set (str/split v-decoded #","))
                :edn (edn/read-string v-decoded)
                :uuid (u/uuid v-decoded)
                v-decoded))))))))

(def default-screen-params-shape
  {:uuid :uuid
   :id :integer})

(defn coerce-param [shape acc [nm input-val]]
  (let [nm (keyword (str/lower nm))
        coerce-type (get shape nm)
        coerced-val
        (when (u/presence input-val)
          (case coerce-type
            :keyword (keyword input-val)
            :integer (u/parseInt input-val)
            :float (u/parseFloat input-val)
            :vector (vec (str/split input-val #","))
            :set (set (str/split input-val #","))
            :edn (edn/read-string input-val)
            :uuid (u/uuid input-val)
            input-val))]
    (assoc acc nm coerced-val)))

(defn update-query-params [app-atom]
  (let [{:keys [history config]} @history-atom
        current-token (get-token history config)
        {:keys [root vals base]} (current-values current-token config)
        shape (merge default-screen-params-shape (screen-params-shape root))
        vals (reduce (partial coerce-param shape) {} vals)]
    (swap! app-atom update-in [:page root] assoc
      :params vals
      :base base)))

(defn handle-url-change [app-atom e]
  #?(:cljs
     (when (.-isNavigation ^goog e)
       (.log js/console "Updating bindings")
       (update-query-params app-atom)
       (update-bindings)
       ;; let's scroll to the top to simulate a navigation
       #_(js/window.scrollTo 0 0))
     :clj
     ;; For clj side, 'e' is just the url directly.
     (do
       (swap! history-atom assoc-in [:history :token] e)
       (update-query-params app-atom)
       (update-bindings))))

(defn replace-url!
  "Replace the current browser URL without navigating, reloading or adding a
   history entry (e.g. canonicalising a product URL after load). No-op on the
   JVM — SSR renders at whatever URL it was asked for."
  [url]
  #?(:cljs (.replaceState js/history nil "" url)
     :clj nil))

;; TODO: clj side, SSR would need to initiate a redirect?
(defn navigate [app-atom e url]
  (let [{:keys [bindings root config history]} @history-atom
        {:keys [fragment?]} config]
    #?(:cljs
       (do
         (when e (.preventDefault e))
         (.setToken ^Html5History history url)
         (update-query-params app-atom)
         (.scrollTo js/window 0 0))
       :clj
       (do
         (uc/error "Navigate not implemented yet - needs to initiate redirect somehow?")))

    (update-bindings)))

(defn- transformer-create-url
  [token path-prefix location]
  (str path-prefix token))

(defn- transformer-retrieve-token
  [path-prefix location]
  (str (.-pathname location) (.-search location) (.-hash location)))

(defn setup-history [app-atom {:keys [fragment?] :as opts}]
  #?(:cljs
     (let [transformer (Html5History.TokenTransformer.)
           _
           (set! (.. transformer -retrieveToken) transformer-retrieve-token)
           _
           (set! (.. transformer -createUrl) transformer-create-url)

           _ (println "creating history")
           _ (.log js/console transformer)
           history
           (doto
             (if fragment?
               (Html5History.)
               (Html5History. js/window transformer))
             (.setPathPrefix
               (str js/window.location.protocol
                 "//"
                 js/window.location.host))
             (.setUseFragment fragment?)
             (goog.events/listen EventType.NAVIGATE
               ;; wrap in a fn to allow live reloading
               #(handle-url-change app-atom %))

             (.setEnabled true))]
       (swap! history-atom assoc :history history :config opts))
     :clj
     (swap! history-atom assoc :history {} :config opts)))

;; TODO: Add binding-type minor/major so that we can control whether changes here should
;; update or add to the history - perhaps call it something more direct, like :history
;; :keep or :replace. better than :minor/:major
(defn bind-nav-fragment
  "Setup a two-way fragment binding with a, using url fragment key nm - and coercing to
   correct type before swapping in on change (:string, :keyword, :integer)"
  [a nm coerce-type & [transition-fn]]
  ;; Only do something if not already bound.
  (let [{:keys [bindings root]} @history-atom
        current-page @root]

    (when-not (get-in @history-atom [:bindings current-page nm :a])
      ;; Add named binding
      (swap! history-atom assoc-in [:bindings current-page nm] {:a a :coerce-type coerce-type})

      ;; Load the current value in.
      (update-bindings)

      ;; Update the url bar with current value (without browsing)
      (update-url false)

      ;; Change nav when atom value changes
      (add-watch a ::nav
        (fn [k r o n]
          (when (and (= @root current-page) (not= o n))
            (update-url true)
            (when transition-fn
              (transition-fn))))))))

(defn bind-root-fragment
  "Sets up a two-way binding with a screen root. This helps namespace bindings so that
   we only sync bindings to atoms in the current screen

   The value in 'a' should always be a keyword."
  [a]

  (swap! history-atom assoc :root a)

  (update-bindings)
  (update-url false)

  (add-watch a ::nav
    (fn [k r o n]
      (when (not= o n) (update-url true)))))

(defn url [link & [getparams]]
  (let [params
        (->>
          (remove (comp nil? val) getparams)
          (map (fn [[k v]] (str (url/url-encode (name k)) "=" (url/url-encode v))))
          (remove str/blank?)
          (str/join "&"))]

    (if (u/presence params)
      (str link "?" params)
      (str link))))

;; TODO: this is a stopgap for now, this needs to be generalized in the actual history setup directly.
;; For now, this should allow use to build mostly what we need
(defn href-link [app-atom root & [action params]]
  (let [app (str/safe-name (or (cmn/curact app-atom [:app :app]) :web))
        prefix (if (= app "admin") "/admin/" "/")]
    (url
      (when root
        (str prefix root ".htm"))
      (u/maybe assoc params
        :action (u/presence action)))))

(defn href-props [app-atom root & [action params]]
  (let [app (str/safe-name (or (cmn/curact app-atom [:app :app]) :web))
        link (href-link app-atom root action params)
        s (if action (keyword (str app "." root) action) (keyword (str app "." root)))]
    (u/maybe assoc
      {:href link}
      :on-click
      (when (contains? (methods flow/render-screen) s)
        (fn [e]
          (when-not (and e (.-currentTarget e) (= (.getAttribute (.-currentTarget e) "target") "_blank"))
            (navigate app-atom e link)))))))

(defn href-on-click [on-click-fn]
  {:href "#"
   :on-click
   (fn [e]
     #?(:cljs
        (.preventDefault e))
     (on-click-fn))})

;; TODO: Same todo as href-props
(defn redirect [app-atom root & [action params force-redirect?]]
  (let [app (str/safe-name (get-in @app-atom [:app :app] :web))
        s (if action (keyword (str app "." root) action) (keyword (str app "." root)))
        link (href-link app-atom root action params)]
    (swap! app-atom assoc-in [:redirect :uri] link)
    (cond
      force-redirect?
      (redirect! link)

      (contains? (methods flow/render-screen) s)
      (navigate app-atom nil link)

      :else
      (redirect! link))))

(defn raw-redirect [app-atom link]
  (println "link: " link)
  (swap! app-atom assoc-in [:redirect :uri] link)
  (redirect! link))

(defn back [& _]
  #?(:clj nil
     :cljs (.back js/history)))

(defn- safe-url-decode
  "Decodes v, or returns it unchanged when it isn't valid percent-encoding.
   Params usually arrive already decoded, so a literal % (e.g. a search for
   \"100% Cotton\") would otherwise throw on the second decode."
  [v]
  (try
    (url/url-decode v)
    (catch #?(:clj Exception :cljs :default) _
      v)))

(defn clean-params [params]
  (reduce
    (fn [acc [k v]]
      (assoc acc k
        (if (coll? v)
          (map safe-url-decode v)
          (safe-url-decode v))))
    {}
    params))
